import { getAllUser } from 'api'
import { createContext, useEffect, useState } from 'react'

interface Context {
  users: any[]
  setUsers: (users: any[]) => void
  loading: boolean
  setLoading: (loading: boolean) => void
  selectedUser: any
  setSelectedUser: (username: any) => void
}
export const UserContext = createContext<Context>({
  users: [],
  setUsers: () => {},
  loading: false,
  setLoading: () => {},
  selectedUser: {},
  setSelectedUser: () => {}
})

interface Props {
  children: any
}

const UserContextProvider = ({ children }: Props) => {
  const [users, setUsers] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [selectedUser, setSelectedUser] = useState()

  const getUsers = async () => {
    setLoading(true)
    try {
      const usersResult = await getAllUser()
      if (usersResult.data.success) {
        const users = usersResult.data.users
        const filteredUsers = users.map((user: any) => ({
          ...user,
          id: user._id
        }))
        setUsers(filteredUsers)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getUsers()
  }, [])

  return (
    <UserContext.Provider
      value={{
        users,
        setUsers,
        loading,
        setLoading,
        selectedUser,
        setSelectedUser
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export default UserContextProvider
